import { ChatMessage } from 'shared/interfaces/ChatMessage';

export type ChatMessageReadable = {
  sourceReadable: string;
  textReadable: string;
};

export const formatChatMessageToReadable = (chatMessage: ChatMessage): ChatMessageReadable => {
  return {
    sourceReadable: chatMessage.fromUser ? 'User' : 'Agent',
    textReadable: chatMessage.text
  };
};

export const getSessionConversationIdKey = (smartAssistantId: string) => {
  return `droxy-guest-conversation-id-${smartAssistantId}`;
};
